import { Component } from "react";
import FlexView from "react-flexview";
import CardBiaxialChart from "../../../../../cards/BiaxialChart";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { configLast3Years, transformResponseLastThreeYearsToTable, yearOptions } from "../config";
import { service } from '../service';
import React from "react";
class LastThreeYearsSales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      tableConfig: [],
      dataTable: [],
      chartVisible: false,
      chartLast3Years: null,
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear()
      ),
      tableConfig: configLast3Years(),
    }));
  }

  compareObject = (data1,data2)=>{
    return JSON.stringify(data1) === JSON.stringify(data2)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.compareObject(prevProps.search, this.props.search)===false) {
      this.fetchData();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.setState(prev=>({
      ...prev,
      tableConfig: configLast3Years(prev.year?.value)
    }), ()=> this.fetchData())
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO").getLaporanJualan3TahunTerakhir,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang By Sales - Laporan Jualan 3 Tahun Terakhir",
        args: {
          kodeCabang: [this.props.search.selectedCabang],
          mode: "SALESMAN",
          year: this.state.year?.value,
          idLeader: null,
          idSalesman: this.props.search.selectedSales
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: transformResponseLastThreeYearsToTable(res.data.data),
        }));
      }
      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log("errors: ", error);
    }
  };

  handleChartVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      chartVisible: !prevValue.chartVisible,
    }));
  };

  render() {
    const {data,dataKey} = service.transformChartData(
      this.state.dataTable, this.state.tableConfig
    );
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            isClearable
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        {!this.state.chartVisible && (
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.state.tableConfig}
          />
        )}
        {this.state.chartVisible && (
          <CardBiaxialChart data={data} dataKey={dataKey} />
        )}
        <FlexView style={{ justifyContent: "end", marginTop: "15px" }}>
          <SimpleButton onClick={this.handleChartVisibility}>
            Chart
          </SimpleButton>
        </FlexView>
      </>
    );
  }
}

export default LastThreeYearsSales;